import React, { useEffect, useLayoutEffect, useRef } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

// Import Layout
import MainLayout from "./Components/Menu/MainLayout"; // <--- IMPORT THE NEW LAYOUT

// Import Pages
import Home from "./pages/Home/Home";
import ContactUs from "./pages/ContactUs";
import Overview from "./pages/Overview/Overview";
import About from "./pages/About";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Team from "./pages/Team";
import WorkShopandWebinar from "./pages/WorkShopandWebinar";
import Success from "./pages/Overview/Success";
import Webinar from "./pages/Webinar";
import LearningHub from "./pages/LearningHub";
import HowToSeries from "./pages/HowToSeries";
import HowtoConductMLandTFRiskAssessment from "./pages/HowToSeries/HowtoConductMLandTFRiskAssessment";
import HowtoComplywithFCAConsumerDuty from "./pages/HowToSeries/HowtoComplywithFCAConsumerDuty";
import HowtoPrepareforanHMRCAudit from "./pages/HowToSeries/HowtoPrepareforanHMRCAudit";
import HowtoStartaCurrencyExchangeBureau from "./pages/HowToSeries/HowtoStartaCurrencyExchangeBureau";
import HowtoStayCompliantwithRegDataSubmissions from "./pages/HowToSeries/HowtoStayCompliantwithRegDataSubmissions";
import HowtoRenewHMRCMLR from "./pages/HowToSeries/HowtoRenewHMRCMLR";
import WelcomeMeet from "./pages/WelcomeMeet/WelcomeMeet";
import SummerMeet from "./pages/WelcomeMeet/SummerMeet";
import EventsDetails from "./pages/Event/EventsDetails";
import WhatsHappening from "./pages/WhatsHappening";
import WelcomeMeet2025details from "./pages/EventDetails/WelcomeMeet2025details";
import AnnualMembersMeet2026Details from "./pages/EventDetails/AnnualMembersMeet2026Details";
import Webinars from "./pages/Webinars";
import HowEmailAndMobileVerificationCanCutCustomerOnboardingCosts from "./pages/Webinars/HowEmailAndMobileVerificationCanCutCustomerOnboardingCosts";
import DosAndDontsToGetaBankAccountForYourMSBBusiness from "./pages/Webinars/DosAndDontsToGetaBankAccountForYourMSBBusiness";
import AllEvents from "./pages/AllEvents";
import EventCalander from "./pages/Event/EventCalander";
import AllPhoto2025 from "./pages/Gallery/Year2025/AllPhoto2025";
import Error from "./pages/Error";
import Blogs from "./pages/Blogs/Blogs";
import TheFutureofCashIsCashProcessingMSBaDyingBusiness from "./pages/Blogs/TheFutureofCashIsCashProcessingMSBaDyingBusiness";
import ABeginnersGuidetoMSBRegulationintheUK from "./pages/Blogs/ABeginnersGuidetoMSBRegulationintheUK";
import UnderstandingKYCandCustomerDueDiligenceforMSBs from "./pages/Blogs/UnderstandingKYCandCustomerDueDiligenceforMSBs";
import CommonComplianceMistakesMSBsMakeAndHowtoAvoidThem from "./pages/Blogs/CommonComplianceMistakesMSBsMakeAndHowtoAvoidThem";
import News from "./pages/News/News";
import CalyxSolutionsStandsforMigrantCommunitiesattheFCAMeeting from "./pages/News/CalyxSolutionsStandsforMigrantCommunitiesattheFCAMeeting";
import BestPracticesforCustomerDataProtectionandPrivacyinMSBs from "./pages/Blogs/BestPracticesforCustomerDataProtectionandPrivacyinMSBs";
import HowtoOnboardandTrainStaffforComplianceinaUKMSB from "./pages/Blogs/HowtoOnboardandTrainStaffforComplianceinaUKMSB";
import HowMSBsCanEnhanceCustomerTrustThroughTransparency from "./pages/Blogs/HowMSBsCanEnhanceCustomerTrustThroughTransparency";
import TheCostofNonCompliancePenaltiesReputationandBusinessRisks from "./pages/Blogs/TheCostofNonCompliancePenaltiesReputationandBusinessRisks";
import FutureTrendsInRemittances from "./pages/Blogs/FutureTrendsInRemittances";
import NavigatingVatTaxesandFinancialReporting from "./pages/Blogs/NavigatingVatTaxesandFinancialReporting";
import WhenLoveBecomesaThreatIdentifyingVulnerabilitiestoRomanceFraud from "./pages/Blogs/WhenLoveBecomesaThreatIdentifyingVulnerabilitiestoRomanceFraud";
import LessonsLearnedFromFailedMoneyServiceBusinesses from "./pages/Blogs/LessonsLearnedFromFailedMoneyServiceBusinesses";
import LegalInsightsOnBuyingOrLeasingCommercialProperty from "./pages/Webinars/LegalInsightsOnBuyingOrLeasingCommercialProperty";
import EffectiveMarketingStrategiesForMoneyServicesBusinesses from "./pages/Blogs/EffectiveMarketingStrategiesForMoneyServicesBusinesses";
import KeyComplianceDatesForMSBsIn2026 from "./pages/Blogs/KeyComplianceDatesForMSBsIn2026";
import AreTraditionalMSBsLosingGroundToDigitalPlayers from "./pages/Blogs/AreTraditionalMSBsLosingGroundToDigitalPlayers";
import TransactionMonitoringManualVsAutomated from "./pages/Blogs/TransactionMonitoringManualVsAutomated";
import WhatBanksExpectFromMSBs from "./pages/Blogs/WhatBanksExpectFromMSBs";
import HowEconomicPressureImpactsRemittanceVolumesAndRisk from "./pages/Blogs/HowEconomicPressureImpactsRemittanceVolumesAndRisk";
import TheRealDifferenceBetweenAStableMSBAndAStrugglingOne from "./pages/Blogs/TheRealDifferenceBetweenAStableMSBAndAStrugglingOne";
import PartnershipStrategiesThatHelpMSBsGrowFaster from "./pages/Blogs/PartnershipStrategiesThatHelpMSBsGrowFaster";
import HowAIWillShapeTheFutureOfCrossBorderPaymentsForMSBs from "./pages/Blogs/HowAIWillShapeTheFutureOfCrossBorderPaymentsForMSBs";
import TransactionFrozenNowWhatHandlingFraudDisputesAndCustomerLiabilityInMSBs from "./pages/Blogs/TransactionFrozenNowWhatHandlingFraudDisputesAndCustomerLiabilityInMSBs";
import HMRCVisitPreparation from "./pages/Webinars/HMRCVisitPreparation";
import FCASupervision2009ToToday from "./pages/Webinars/FCASupervision2009ToToday";
import PanelistDetails from "./pages/PanelistDetails";
import Videogallery2025 from "./pages/Gallery/Videogallery2025";
import Videogallery2026 from "./pages/Gallery/Videogallery2026";
import PhotoGallery2026 from "./pages/Gallery/PhotoGallery2026";
import DiscussionPanelists from "./pages/HomeComonents/DiscussionPanelists";
import MemberShipFormSumUp from "./pages/Overview/MemberShipFormSumUp";
import MemberPaymentReturn from "./pages/Overview/MemberPaymentReturn";
import SummerMembersMeet2026Details from "./pages/EventDetails/SummerMembersMeet2026Details";

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Failed to load script ${src}`));
    document.body.appendChild(script);
  });
}

function App() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const hasNormalizedRef = useRef(false);
  const baseUrl =
    typeof window !== "undefined" && process.env.NODE_ENV !== "production"
      ? window.location.origin
      : "https://msbassociationuk.org";
  const defaultImage = `${baseUrl}/assets/images/logo.png`;
  const seoByPath = {
    "/": {
      title: "MSB Association UK | Empowering Money Service Businesses in UK",
      description:
        "Join the MSB Association, the hub for UK Money Service Businesses. Access compliance support, industry advocacy, and tools to grow and safeguard your business.",
      image: defaultImage,
    },
    "/become-a-member": {
      title: "Join MSB Association | MSB Association Membership Benefits",
      description:
        "Join MSB Association and unlock exclusive membership benefits, including compliance support, banking access, fraud prevention resources, and industry advocacy for MSB.",
      image: `${baseUrl}/assets/images/logo.svg`,
    },
    "/about-us": {
      title: "About MSB Association | Money Service Business Advocacy UK",
      description:
        "Learn about our mission and vision for the MSB sector. Discover how the MSB Association supports Money Service Businesses through advocacy & community networking.",
      image: defaultImage,
    },
    "/contact-us": {
      title: "Contact MSB Association UK | Get in Touch",
      description:
        "Contact the MSB Association UK for membership, compliance support, events, and partnerships.",
      image: defaultImage,
    },
    "/overview": {
      title: "Join MSB Association | MSB Association Membership Benefits",
      description:
        "Join MSB Association and unlock exclusive membership benefits, including compliance support, banking access, fraud prevention resources, and industry advocacy for MSB.",
      image: `${baseUrl}/assets/images/logo.svg`,
    },
    "/workshop-webinars": {
      title: "Workshops & Webinars | MSB Association UK",
      description:
        "Explore MSB Association workshops and webinars on AML compliance, operations, and banking access.",
      image: defaultImage,
    },
    "/our-team": {
      title: "Our Team | Meet the Experts Behind MSB Association",
      description:
        "Get to know the professionals driving the MSB Association’s mission to support Money Service Businesses in the UK.",
      image: defaultImage,
    },
    "/member-success": {
      title: "Member Success | MSB Association UK",
      description:
        "Real stories of MSB Association members achieving compliance and growth with our support.",
      image: defaultImage,
    },
    "/member-payment-return": {
      title: "Confirming Membership Payment | MSB Association UK",
      description:
        "Confirming your MSB Association membership payment and activating your membership.",
      image: defaultImage,
    },
    "/privacy-policy": {
      title: "Privacy Policy | MSB Association UK",
      description:
        "Read how MSB Association collects, uses, and protects your data in accordance with applicable laws.",
      image: defaultImage,
    },
    "/terms-and-conditions": {
      title: "Terms and Conditions | MSB Association UK",
      description:
        "Review the terms and conditions for using MSB Association services and website.",
      image: defaultImage,
    },
    "/webinar-registration": {
      title: "Register for Webinars | MSB Association UK",
      description:
        "Register for upcoming MSB Association webinars covering compliance, risk, and operations.",
      image: defaultImage,
    },
    "/learning-hub": {
      title: "Learning Hub | Guides and Resources for MSBs",
      description:
        "Access MSB-focused guides, resources, and insights to strengthen your compliance and operations.",
      image: defaultImage,
    },
    "/how-to-series": {
      title: "How To Series | Practical Guides for MSBs",
      description:
        "Step-by-step guidance for UK MSBs on compliance, HMRC, FCA expectations, and operations.",
      image: defaultImage,
    },
    "/how-to-conduct-ml-and-tf-risk-assessment": {
      title: "How to Conduct ML and TF Risk Assessment | MSB Association UK",
      description:
        "A practical guide to performing ML/TF risk assessments for Money Service Businesses in the UK.",
      image: defaultImage,
    },
    "/how-to-comply-with-fca-consumer-duty": {
      title: "How to Comply with FCA Consumer Duty | MSB Association UK",
      description:
        "Understand FCA Consumer Duty and what MSBs need to do to comply effectively.",
      image: defaultImage,
    },
    "/how-to-prepare-for-an-hmrc-audit": {
      title: "How to Prepare for an HMRC Audit | MSB Association UK",
      description:
        "What to expect during an HMRC compliance check and how MSBs can prepare.",
      image: defaultImage,
    },
    "/how-to-start-a-currency-exchange-bureau": {
      title: "How to Start a Currency Exchange Bureau | MSB Association UK",
      description:
        "Key steps to start a currency exchange bureau in the UK, from registration to marketing.",
      image: defaultImage,
    },
    "/how-to-stay-compliant-with-regdata-submissions": {
      title:
        "How to Stay Compliant with RegData Submissions | MSB Association UK",
      description:
        "Ensure accurate and timely RegData submissions with this practical MSB checklist.",
      image: defaultImage,
    },
    "/how-to-renew-hmrc-mlr": {
      title: "How to Renew HMRC MLR Registration | MSB Association UK",
      description:
        "Everything MSBs need to renew HMRC MLR registration without headaches.",
      image: defaultImage,
    },
    "/welcome-meet": {
      title: "Welcome Meet | MSB Association UK",
      description:
        "Discover details about MSB Association welcome meet events and community updates.",
      image: defaultImage,
    },
    "/whats-happening": {
      title: "What’s Happening | MSB Association UK",
      description:
        "Latest updates, activities, and announcements from the MSB Association.",
      image: defaultImage,
    },
    "/eventcalander": {
      title: "Events Calendar | MSB Association UK",
      description:
        "Browse upcoming MSB Association events, workshops, and webinars.",
      image: defaultImage,
    },
    "/eventsdetails": {
      title:
        "FSA/FCA supervision history & remittance firm expectations | MSB Association",
      description:
        "Join Mr. James Borley for a free webinar on how MSB supervision has evolved since 2009. Thursday, 20th August 2026, 2:00 PM (UK Time).",
      image: defaultImage,
    },
    "/fca-supervision-2009-to-today": {
      title:
        "FCA Supervision of MSBs Since 2009 | MSB Association",
      description:
        "On 20th August, Mr. James Borley, Director for Payment Services at Complyport, explored how FSA/FCA supervision of Money Service Businesses has evolved since 2009.",
      image: defaultImage,
    },
    "/events": {
      title: "All Events | MSB Association UK",
      description: "Explore all MSB Association events and community meetups.",
      image: defaultImage,
    },
    "/": {
      title: "MSB Association UK | Empowering Money Service Businesses in UK",
      description:
        "Highlights and insights from the MSB Association London meetup",
      image: defaultImage,
    },
    "/welcome-msb-meet-june-2025": {
      title: "Welcome MSB Meet-Up 19th June 2025 | MSB Association UK",
      description:
        "Highlights and insights from the MSB Association London meetup on 19th June 2025.",
      image: `${baseUrl}/assets/images/events/welcome-meet-june.png`,
    },
    "/annual-members-meet-2026": {
      title: "Annual Members Meet 16th April 2026 | MSB Association UK",
      description:
        "Highlights and insights from the MSB Association London Annual Members Meet on 16th April 2026.",
      image: `${baseUrl}/assets/images/events/annual-members-meet-2026-main.png`,
    },
    "/webinars": {
      title: "MSB Webinars | Compliance, Operations, Banking Access",
      description:
        "Attend expert-led MSB webinars on compliance, AML, banking access, and operational excellence.",
      image: defaultImage,
    },
    "/how-email-and-mobile-verification-can-cut-customer-onboarding-costs": {
      title:
        "How Email & Mobile Verification Can Cut Onboarding Costs | MSB Association UK",
      description:
        "Reduce onboarding costs and fraud with smart verification—insights for MSBs.",
      image: defaultImage,
    },
    "/dosand-donts-to-get-a-bank-account-for-your-msb-business": {
      title:
        "Dos and Don’ts to Get a Bank Account for Your MSB | MSB Association UK",
      description:
        "Practical tips to improve your chances of securing banking for your MSB.",
      image: defaultImage,
    },
    "/blogs": {
      title: "MSB Blogs | Insights for UK Money Service Businesses",
      description:
        "Expert insights and practical guidance for UK MSBs on compliance, banking, and growth.",
      image: defaultImage,
    },
    "/future-of-cash-processing-msbs-uk": {
      title:
        "The Future of Cash - Is Cash Processing MSB a Dying Business? | MSB Association UK",
      description:
        "Why cash isn’t disappearing in the UK. How MSBs are modernising cash processing to stay compliant, inclusive, and essential. Data, compliance, and the road ahead.",
      image: `${baseUrl}/assets/images/blogs/future-of-cash-processing-msbs-uk.png`,
    },
    "/guide-to-msb-regulation-uk-guide": {
      title:
        "A Beginner’s Guide to MSB Regulation in the UK | MSB Association UK",
      description:
        "Learn the basics of MSB regulation in the UK, including compliance requirements, FCA registration, and how money service businesses operate legally.",
      image: `${baseUrl}/assets/images/blogs/guide-to-msb-regulation-uk-guide.png`,
    },
    "/kyc-cdd-msbs": {
      title:
        "Understanding KYC & Customer Due Diligence for MSBs | MSB Association UK",
      description:
        "Learn about KYC and Customer Due Diligence requirements for Money Service Businesses (MSBs) to ensure compliance and prevent fraud.",
      image: `${baseUrl}/assets/images/blogs/kyc-cdd-msbs.png`,
    },
    "/common-compliance-mistakes-msbs": {
      title:
        "Common Compliance Mistakes MSBs Make & How to Avoid Them | MSB Association UK",
      description:
        "Money Service Businesses (MSBs) such as money remittance services, currency exchanges, and cheque cashers operate in a highly regulated environment. Ensuring compliance with anti-money laundering (AML) laws and other regulations is crucial to avoid hefty fines and reputational damage. This article highlights some of the most common compliance mistakes made by MSBs and provides practical tips on how to avoid them.",
      image: `${baseUrl}/assets/images/blogs/common-compliance-mistakes-msbs.png`,
    },
    "/customer-data-protection-privacy-msbs": {
      title:
        "Best Practices for Customer Data Protection & Privacy in MSBs | MSB Association UK",
      description:
        "Discover actionable best practices for protecting customer data and ensuring privacy compliance in UK MSBs. Learn how to meet GDPR standards, strengthen security, and build customer trust.",
      image: `${baseUrl}/assets/images/blogs/customer-data-protection-privacy-msbs.png`,
    },
    "/how-to-onboard-and-train-staff-for-compliance-in-uk-msb": {
      title:
        "How to Onboard & Train Staff for Compliance in a UK MSB? | MSB Association UK",
      description:
        "Learn how UK Money Service Businesses (MSBs) can onboard and train staff effectively to meet AML compliance under HMRC’s MLR 2017. Discover best practices for vetting, AML training, and ongoing compliance monitoring.",
      image: `${baseUrl}/assets/images/blogs/how-to-onboard-and-train-staff-for-compliance-in-uk-msb.png`,
    },
    "/how-msbs-can-enhance-customer-trust-through-transparency": {
      title:
        "How MSBs Can Enhance Customer Trust Through Transparency? | MSB Association UK",
      description:
        "Discover how Money Service Businesses (MSBs) can build lasting customer trust through transparency. Learn practical ways to improve communication, show compliance, and strengthen loyalty in today’s financial market.",
      image: `${baseUrl}/assets/images/blogs/how-msbs-can-enhance-customer-trust-through-transparency.png`,
    },
    "/the-cost-of-non-compliance-msb-risks-penalties": {
      title:
        "The Cost of Non-Compliance: Penalties, Reputation, and Business Risks | MSB Association UK",
      description:
        "Explore the true cost of non-compliance for UK MSBs — from FCA penalties to reputational damage and business risks. Learn how compliance drives success.",
      image: `${baseUrl}/assets/images/blogs/the-cost-of-non-compliance-msb-risks-penalties.png`,
    },
    "/news": {
      title: "MSB Association News | MSB Association UK",
      description: "Latest news and updates from the MSB Association UK.",
      image: `${baseUrl}/assets/images/news/news.png`,
    },
    "/news/calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting": {
      title:
        "Calyx Solutions Stands for Migrant Communities at the FCA Meeting | MSB Association UK",
      description:
        "At Calyx Solutions, we remain committed to addressing the challenges faced by high-risk and underserved communities, including migrant communities. We recently had the opportunity to represent these communities at a meeting with the Financial Conduct Authority (FCA) to discuss the barriers they face in accessing financial services.",
      image: `${baseUrl}/assets/images/news/calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting.jpg`,
    },
    "/are-traditional-msbs-losing-ground-to-digital-players": {
      title:
        "Are traditional MSBs losing ground to digital players? | MSB Association UK",
      description:
        "Money Service Businesses (MSBs), including money remittance providers, currency exchange operators, and cheque cashers, play a critical role in the financial ecosystem.",
      image: `${baseUrl}/assets/images/blogs/are-traditional-msbs-losing-ground-to-digital-players.png`,
    },
    "/transaction-monitoring-manual-vs-automated": {
      title:
        "Transaction Monitoring: Manual vs Automated – What makes sense for smaller MSBs? | MSB Association UK",
      description:
        "Should smaller MSBs rely on manual monitoring, adopt automation, or use a combination of both? Explore what approach makes the most practical sense for smaller MSBs. Transaction monitoring is your business's safety net.",
      image: `${baseUrl}/assets/images/blogs/transaction-monitoring-manual-vs-automated.png`,
    },
    "/what-banks-expect-from-msbs-during-annual-reviews": {
      title:
        "What banks expect from MSBs during annual reviews? | MSB Association UK",
      description:
        "This blog explains what banks actually expect from MSBs during annual reviews, and how businesses can prepare effectively.",
      image: `${baseUrl}/assets/images/blogs/What-banks-expect-from-MSBs-during-annual-reviews.png`,
    },
    "/how-economic-pressure-impacts-remittance-volumes-and-risk": {
      title:
        "How economic pressure impacts remittance volumes and risk? | MSB Association UK",
      description:
        "Economic challenges such as inflation, unemployment, exchange rate volatility, and geopolitical uncertainty can significantly affect remittance volumes and increase compliance, fraud, and operational risks for UK MSBs.",
      image: `${baseUrl}/assets/images/blogs/how-economic-pressure-impacts-remittance-volumes-and-risk.png`,
    },
    "/the-real-difference-between-a-stable-msb-and-a-struggling-one": {
      title:
        "The real difference between a stable MSB and a struggling one | MSB Association UK",
      description:
        "The difference between a stable MSB and a struggling one is rarely about size. Learn how compliance, banking relationships, cash flow, and culture build a resilient UK money service business.",
      image: `${baseUrl}/assets/images/blogs/the-real-difference-between-a-stable-msb-and-a-struggling-one.png`,
    },
    "/partnership-strategies-that-help-msbs-grow-faster": {
      title:
        "Partnership strategies that help MSBs grow faster | MSB Association UK",
      description:
        "Explore six practical partnership strategies that help Money Service Businesses grow faster, including licensed providers, banking, networks, agents, technology platforms, and ecosystem partnerships.",
      image: `${baseUrl}/assets/images/blogs/partnership-strategies-that-help-msbs-grow-faster.png`,
    },
    "/how-ai-will-shape-the-future-of-cross-border-payments-for-msbs": {
      title:
        "How AI will shape the future of cross-border payments for Money Services Businesses | MSB Association UK",
      description:
        "Artificial intelligence is already helping Money Services Businesses cut costs, speed up processes, and strengthen controls in cross-border payments. Learn how AI is reshaping monitoring, onboarding, fraud prevention, routing, and decision-making for MSBs.",
      image: `${baseUrl}/assets/images/blogs/how-ai-will-shape-the-future-of-cross-border-payments-for-msbs.png`,
    },
    "/transaction-frozen-now-what-handling-fraud-disputes-and-customer-liability-in-msbs": {
      title:
        "Transaction frozen, now what? Handling fraud disputes and customer liability in MSBs | MSB Association UK",
      description:
        "Learn what Money Services Businesses should do when a transaction is frozen, how to manage fraud disputes, and how customer liability differs for unauthorised payments and authorised scam transfers.",
      image: `${baseUrl}/assets/images/blogs/transaction-frozen-now-what-handling-fraud-disputes-and-customer-liability-in-msbs.png`,
    },
    "/discussion-panel-2026": {
      title: "Discussion Panelists | MSB Association UK",
      description: "Meet our expert discussion panelists who are shaping the future of money service businesses in the UK.",
      image: defaultImage,
    },
    "/video-gallery-2026": {
      title: "Video Gallery 2026 | MSB Association UK",
      description: "View videos from the 2026 MSB Association events and webinars.",
      image: defaultImage,
    },
    "/summer-meet-2026": {
      title: "Summer Members Meet 2026 | MSB Association UK",
      description:
        "Join the MSB Association Summer Members Meet on 26 June 2026 at 1864 Rooftop Bar & Kitchen, London. Network, connect, and strengthen the MSB community.",
      image: `${baseUrl}/MSB-summer-members-meet.png`,
    },
  };
  const currentSeo = seoByPath[pathname] || seoByPath["/"];
  const canonicalUrl = `${baseUrl}${pathname || "/"}`;

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Normalize trailing slash exactly once per mount to avoid any loops
  useEffect(() => {
    if (hasNormalizedRef.current) return;
    if (pathname.length > 1 && pathname.endsWith("/")) {
      const target = pathname.replace(/\/+$/, "");
      hasNormalizedRef.current = true;
      if (target !== pathname) {
        navigate(target + window.location.search + window.location.hash, {
          replace: true,
        });
      }
    }
  }, [pathname, navigate]);

  useEffect(() => {
    const isSnap =
      typeof navigator !== "undefined" &&
      /reactSnap/i.test(navigator.userAgent);
    const isLocalhost =
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1");
    if (isSnap || isLocalhost) return; // Skip during prerender and local dev
    const scripts = [
      "/assets/js/jquery.min.js",
      "/assets/js/swiper.js",
      "/assets/js/slider.js",
      "/assets/js/bootstrap.js",
      "/assets/js/wow.js",
      "/assets/js/autocount.js",
      "/assets/js/tilt.jquery.js",
      "/assets/js/main.js",
    ];

    const loadAllScripts = async () => {
      for (let src of scripts) {
        try {
          if (!document.querySelector(`script[src='${src}']`)) {
            await loadScript(src);
          }
        } catch (err) {
          console.error(err);
        }
      }
    };

    loadAllScripts();
  }, []);

  return (
    <div className="App">
      <Helmet
        defaultTitle="MSB Association UK"
        titleTemplate="%s | MSB Association UK"
      >
        {currentSeo?.title && <title>{currentSeo.title}</title>}
        {currentSeo?.description && (
          <meta name="description" content={currentSeo.description} />
        )}
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:site_name" content="MSB Association UK" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={currentSeo?.title || "MSB Association UK"}
        />
        <meta
          property="og:description"
          content={currentSeo?.description || ""}
        />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={currentSeo?.image || defaultImage} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={currentSeo?.title || "MSB Association UK"}
        />
        <meta
          name="twitter:description"
          content={currentSeo?.description || ""}
        />
        <meta
          name="twitter:image"
          content={currentSeo?.image || defaultImage}
        />
      </Helmet>
      <Routes>
        {/* Routes with Header and Footer */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="become-a-member" element={<Overview />} />
          <Route path="become-a-member-sumup" element={<MemberShipFormSumUp />} />
          <Route path="overview" element={<Overview />} />
          <Route path="workshop-webinars" element={<WorkShopandWebinar />} />
          <Route path="our-team" element={<Team />} />
          <Route path="member-success" element={<Success />} />
          <Route path="member-payment-return" element={<MemberPaymentReturn />} />
          <Route path="about-us" element={<About />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-and-conditions" element={<TermsConditions />} />
          <Route path="webinar-registration" element={<Webinar />} />
          <Route path="learning-hub" element={<LearningHub />} />
          <Route path="how-to-series" element={<HowToSeries />} />

          <Route path="discussion-panel-2026" element={<PanelistDetails />} />
          <Route
            path="how-to-conduct-ml-and-tf-risk-assessment"
            element={<HowtoConductMLandTFRiskAssessment />}
          />
          <Route
            path="how-to-comply-with-fca-consumer-duty"
            element={<HowtoComplywithFCAConsumerDuty />}
          />
          <Route
            path="how-to-prepare-for-an-hmrc-audit"
            element={<HowtoPrepareforanHMRCAudit />}
          />
          <Route
            path="how-to-start-a-currency-exchange-bureau"
            element={<HowtoStartaCurrencyExchangeBureau />}
          />
          <Route
            path="how-to-stay-compliant-with-regdata-submissions"
            element={<HowtoStayCompliantwithRegDataSubmissions />}
          />
          <Route path="how-to-renew-hmrc-mlr" element={<HowtoRenewHMRCMLR />} />
          <Route path="welcome-meet" element={<WelcomeMeet />} />
          <Route path="members-meet-2026" element={<WelcomeMeet />} />
          <Route path="summer-meet-2026" element={<SummerMeet />} />
          <Route path="whats-happening" element={<WhatsHappening />} />
          <Route path="eventcalander" element={<EventCalander />} />
          <Route path="eventsdetails" element={<EventsDetails />} />
          <Route
            path="fca-supervision-2009-to-today"
            element={<FCASupervision2009ToToday />}
          />
          <Route path="events" element={<AllEvents />} />
          <Route
            path="welcome-msb-meet-june-2025"
            element={<WelcomeMeet2025details />}
          />
          <Route
            path="annual-members-meet-2026"
            element={<AnnualMembersMeet2026Details />} />
          <Route
            path="summer-members-meet-2026"
            element={<SummerMembersMeet2026Details />} />
            
          <Route path="webinars" element={<Webinars />} />

          <Route
            path="how-email-and-mobile-verification-can-cut-customer-onboarding-costs"
            element={
              <HowEmailAndMobileVerificationCanCutCustomerOnboardingCosts />
            }
          />
          <Route
            path="dosand-donts-to-get-a-bank-account-for-your-msb-business"
            element={<DosAndDontsToGetaBankAccountForYourMSBBusiness />}
          />
          <Route
            path="legal-insights-on-buying-or-leasing-commercial-property"
            element={<LegalInsightsOnBuyingOrLeasingCommercialProperty />}
          />
          <Route
            path="hmrc-visit-preparation"
            element={<HMRCVisitPreparation />}
          />

          {/* Photo Gallery */}
          <Route path="photos2025" element={<AllPhoto2025 />} />
          <Route path="photos-gallery-2025" element={<AllPhoto2025 />} />
          <Route path="photos-gallery-2026" element={<PhotoGallery2026 />} />

          {/* Video Gallery */}
          <Route path="video-gallery-2025" element={<Videogallery2025 />} />
          <Route path="video-gallery-2026" element={<Videogallery2026 />} />
          {/* Discussion Panelists */}
          <Route path="discussion-panelists-2025" element={<DiscussionPanelists />} />

          {/* Blogs */}
          <Route path="blogs" element={<Blogs />} />
          <Route
            path="when-love-becomes-a-threat-identifying-vulnerabilities-to-romance-fraud"
            element={
              <WhenLoveBecomesaThreatIdentifyingVulnerabilitiestoRomanceFraud />
            }
          />
          <Route
            path="navigating-vat-taxes-and-financial-reporting-for-msbs"
            element={<NavigatingVatTaxesandFinancialReporting />}
          />
          <Route
            path="future-trends-in-remittances-msb-what-to-know"
            element={<FutureTrendsInRemittances />}
          />
          <Route
            path="future-of-cash-processing-msbs"
            element={<TheFutureofCashIsCashProcessingMSBaDyingBusiness />}
          />
          <Route
            path="guide-to-msb-regulation-uk-guide"
            element={<ABeginnersGuidetoMSBRegulationintheUK />}
          />
          <Route
            path="kyc-cdd-msbs"
            element={<UnderstandingKYCandCustomerDueDiligenceforMSBs />}
          />
          <Route
            path="common-compliance-mistakes-msbs"
            element={<CommonComplianceMistakesMSBsMakeAndHowtoAvoidThem />}
          />
          <Route
            path="customer-data-protection-privacy-msbs"
            element={<BestPracticesforCustomerDataProtectionandPrivacyinMSBs />}
          />
          <Route
            path="how-to-onboard-and-train-staff-for-compliance-in-uk-msb"
            element={<HowtoOnboardandTrainStaffforComplianceinaUKMSB />}
          />
          <Route
            path="how-msbs-can-enhance-customer-trust-through-transparency"
            element={<HowMSBsCanEnhanceCustomerTrustThroughTransparency />}
          />
          <Route
            path="the-cost-of-non-compliance-msb-risks-penalties"
            element={
              <TheCostofNonCompliancePenaltiesReputationandBusinessRisks />
            }
          />
          <Route
            path="lessons-learned-from-failed-money-service-businesses"
            element={<LessonsLearnedFromFailedMoneyServiceBusinesses />}
          />
          <Route
            path="effective-marketing-strategies-for-money-services-businesses"
            element={<EffectiveMarketingStrategiesForMoneyServicesBusinesses />}
          />
          <Route
            path="key-compliance-dates-for-msbs-in-2026-what-to-watch-out-for"
            element={<KeyComplianceDatesForMSBsIn2026 />}
          />
          <Route
            path="are-traditional-msbs-losing-ground-to-digital-players"
            element={<AreTraditionalMSBsLosingGroundToDigitalPlayers />}
          />
          <Route
            path="transaction-monitoring-manual-vs-automated"
            element={<TransactionMonitoringManualVsAutomated />}
          />
          <Route
            path="what-banks-expect-from-msbs-during-annual-reviews"
            element={<WhatBanksExpectFromMSBs />}
          />
          <Route
            path="how-economic-pressure-impacts-remittance-volumes-and-risk"
            element={<HowEconomicPressureImpactsRemittanceVolumesAndRisk />}
          />
          <Route
            path="the-real-difference-between-a-stable-msb-and-a-struggling-one"
            element={<TheRealDifferenceBetweenAStableMSBAndAStrugglingOne />}
          />
          <Route
            path="partnership-strategies-that-help-msbs-grow-faster"
            element={<PartnershipStrategiesThatHelpMSBsGrowFaster />}
          />
          <Route
            path="how-ai-will-shape-the-future-of-cross-border-payments-for-msbs"
            element={<HowAIWillShapeTheFutureOfCrossBorderPaymentsForMSBs />}
          />
          <Route
            path="transaction-frozen-now-what-handling-fraud-disputes-and-customer-liability-in-msbs"
            element={<TransactionFrozenNowWhatHandlingFraudDisputesAndCustomerLiabilityInMSBs />}
          />

          {/* News */}
          <Route path="news" element={<News />} />
          <Route
            path="news/calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting"
            element={
              <CalyxSolutionsStandsforMigrantCommunitiesattheFCAMeeting />
            }
          />
        </Route>

        {/* Route without Header and Footer (Error Page) */}
        {/* This catch-all route must be last */}
        <Route path="*" element={<Error />} />
      </Routes>
    </div>
  );
}

export default App;
